import { useState, useContext } from "react";
import { convertTimetoString, extractYear } from "../../../helperFunction";
import css from "../Approvals/css/view-modal.module.css";
import DocumentBar from "./DocumentBar";
import { NotAvailable } from "./styles";
import apiCall from "../../../utils/apiCall";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationContext } from "../../../providers/notification";
import { ApplicationsContext } from "../Applications/Applications";
import {
  CVDetails,
  HrTrainingDetails,
  CoreHRExperienceDetails,
  HRStrategiesDetails,
} from "./type";
import styles from "./css/styles.module.css";
import { AcRoute, AcRouteB } from "../../../utils/allRouteId";

interface HRTrainingProps {
  hrTrainingData?: HrTrainingDetails[];
  CVData?: CVDetails[];
  coreHrExperienceData?: CoreHRExperienceDetails[];
  researchWork?: HRStrategiesDetails[];
  handleCancel: (value: boolean) => void;
  routeId: number;
  isReadOnly?: boolean;

}

interface Payload {
  id?: number;
  applicantId?: string;
  qualificationId?: number;
  score: number;
}

export const HRTraining: React.FC<HRTrainingProps> = ({
  routeId,
  hrTrainingData = [],
  CVData = [],
  coreHrExperienceData = [],
  researchWork = [],
  handleCancel,
}) => {
  const [score, setScore] = useState("");
  const [id, setId] = useState<number | undefined>(0);
  const [applicantId, setApplicantId] = useState<string | undefined>("");

  const filterResearchWorks = researchWork.filter(
    (item) => item?.IsResearch == true
  );

  const { isApplicationMenu } = useContext(ApplicationsContext);

  const handleScore = (event: React.ChangeEvent<HTMLInputElement>) => {
    setScore(event.target.value);
  };

  const { showNotification } = useContext(NotificationContext);
  const queryClient = useQueryClient();

  const showScoresUpdate = isApplicationMenu ? false : true;

  const handleHrTrainings = (data?: HrTrainingDetails) => {
    setId(data?.Id);
    setApplicantId(data?.ApplicantId);
  };

  const handleCoreHr = (data?: CoreHRExperienceDetails) => {
    setId(data?.Id);
    setApplicantId(data?.ApplicantId);
  };

  const handleResearchWork = (data?: HRStrategiesDetails) => {
    setId(data?.Id);
    setApplicantId(data?.ApplicantId);
  };

  const url = `/Applicant/UpdateHRScoreByApplicantId?id=${id}&applicantId=${applicantId}&score=${Number(
    score
  )}`;

  const coreHrExperienceurl = `/Applicant/UpdateCoreHRScoreByApplicantId?id=${id}&applicantId=${applicantId}&score=${Number(
    score
  )}`;

  const researchWorkUrl = `/Applicant/UpdateHRStrategyScoreByApplicantId?id=${id}&applicantId=${applicantId}&score=${Number(
    score
  )}`;

  const updateResearchWork = async (data: Payload) => {
    return await apiCall().post(researchWorkUrl, data);
  };

  const updateHrtrainingScore = async (data: Payload) => {
    return await apiCall().post(url, data);
  };

  const updateCoreHrScore = async (data: Payload) => {
    return await apiCall().post(coreHrExperienceurl, data);
  };

  const updateHrTrainingMutation = useMutation(
    ["update-score"],
    updateHrtrainingScore,
    { retry: 0 }
  );

  const updateCoreHrMutation = useMutation(
    ["update-coreHR-score"],
    updateCoreHrScore,
    { retry: 0 }
  );

  const updateResearchWorkMutation = useMutation(
    ["update-ResearchWork"],
    updateResearchWork,
    { retry: 0 }
  );

  const updateResearchWorkScoreHandler = async () => {
    const payload: Payload = {
      id: id,
      applicantId: applicantId,
      score: Number(score),
    };

    try {
      await updateResearchWorkMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: "success",
            message: "Research Work Score has been successfully updated",
          });
          queryClient.refetchQueries(["get-hrStrategies-details", applicantId]);
          queryClient.refetchQueries(["get-all-personal-details"]);
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };

  const updateHrTrainingScoreHandler = async () => {
    const payload: Payload = {
      id: id,
      applicantId: applicantId,
      score: Number(score),
    };

    try {
      await updateHrTrainingMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: "success",
            message: "HR Training Score has been successfully updated",
          });
          queryClient.refetchQueries([
            "get-all-hrTrainings-details",
            applicantId,
          ]);
          queryClient.refetchQueries(["get-all-personal-details"]);
          queryClient.refetchQueries(["get-approval"]);
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };

  const updateCoreHrScoreHandle = async () => {
    const payload: Payload = {
      id: id,
      applicantId: applicantId,
      score: Number(score),
    };

    try {
      await updateCoreHrMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: "success",
            message: "Hr Core Experience Score has been successfully updated",
          });

          queryClient.refetchQueries([
            "get-all-CoreHrExperirnce-details",
            applicantId,
          ]);
          queryClient.refetchQueries(["get-all-personal-details"]);

          setScore("");
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };

  return (
    <div className={`${css.edDiv} ${css.hrD}`}>
      <p className={css.title}>HR Training</p>
      <div className={styles.headingBar}> Core HR Work Experience</div>
      {coreHrExperienceData?.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <table>
            <tr className={styles.tableHead}>
              <th>Specialization</th>
              <th>Activity</th>
              <th>Start Year</th>
              <th>End Year</th>
              <th>Uploaded Document</th>
            </tr>

            {coreHrExperienceData?.length > 0
              ? coreHrExperienceData?.map(
                  (eData: CoreHRExperienceDetails, index: any) => {
                    return (
                      <tr key={index}>
                        {eData?.Specialization == "Others" ? (
                          <td>{eData?.Others} </td>
                        ) : (
                          <td>{eData?.Specialization} </td>
                        )}
                        <td>{eData.Activities} </td>
                        <td>{convertTimetoString(eData?.StartYear, 3)} </td>
                        <td>{convertTimetoString(eData?.EndYear, 3)} </td>
                        <td>
                          {" "}
                          <DocumentBar
                            hideScoreIntegration={showScoresUpdate}
                            docName={`HR WORK EXPERIENCE DOCUMENT`}
                            documentUrl={eData?.CVUrl}
                            onChange={handleScore}
                            score={score}
                            displayScore={eData?.Score}
                            handleSubmit={updateCoreHrScoreHandle}
                            handleVisibility={() => handleCoreHr(eData)}
                            loading={updateCoreHrMutation.isLoading}
                          />
                        </td>
                      </tr>
                    );
                  }
                )
              : "Not Available"}
          </table>
        </div>
      ) : (
        <NotAvailable> Not Available</NotAvailable>
      )}

      <div className={styles.headingBar}>
        HR MANAGEMENT & OTHER RELATED TRAININGS
      </div>
      {hrTrainingData?.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <table>
            <tr className={styles.tableHead}>
              <th>Training</th>
              <th>Title</th>
              <th>Year</th>
              <th>Uploaded Document</th>
            </tr>
            {hrTrainingData?.length > 0
              ? hrTrainingData?.map(
                  (eData: HrTrainingDetails, index: number) => {
                    return (
                      <tr key={index}>
                        <td>{eData?.Training} </td>
                        <td>{eData?.Title} </td>
                        <td>{extractYear(eData?.Date)} </td>
                        <DocumentBar
                          hideScoreIntegration={showScoresUpdate}
                          docName={`HR MANAGEMENT & OTHER RELATED TRAININGS DOCUMENT`}
                          documentUrl={eData?.TrainingURL}
                          onChange={handleScore}
                          handleVisibility={() => handleHrTrainings(eData)}
                          score={score}
                          displayScore={eData?.Score}
                          handleSubmit={updateHrTrainingScoreHandler}
                          loading={updateHrTrainingMutation.isLoading}
                        />
                      </tr>
                    );
                  }
                )
              : ""}
          </table>
        </div>
      ) : (
        <NotAvailable>Not Available</NotAvailable>
      )}

      <div className={styles.headingBar}>CV </div>
      <div style={{ overflowX: "auto", marginBlock: "10px" }}>
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}
        >
          {CVData?.length > 0 ? (
            CVData?.map((eData: CVDetails, index: number) => (
              <div key={index}>
                <DocumentBar
                  hideScoreIntegration={false}
                  docName={`CV DOCUMENT ${index + 1}`}
                  documentUrl={eData?.CVurl}
                  onChange={handleScore}
                />
              </div>
            ))
          ) : (
            <NotAvailable>Not Available</NotAvailable>
          )}
        </div>
      </div>

      {(routeId == Number(AcRouteB) || routeId == Number(AcRoute)) && (
        <>
          <div className={styles.headingBar}>RESEARCH WORK / PUBLICATIONS</div>
          {filterResearchWorks?.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table>
                <tr className={styles.tableHead}>
                  <th>Research Topic/ Publication</th>
                  <th>Description</th>
                  <th>Year</th>
                  <th>Uploaded Document</th>
                </tr>
                {filterResearchWorks?.length > 0
                  ? filterResearchWorks.map(
                      (eData: HRStrategiesDetails, index: number) => (
                        <tr key={index}>
                          <td>{eData?.ProjectName} </td>
                          <td>{eData?.Description} </td>
                          <td> {convertTimetoString(eData?.Year, 3)} </td>
                          <td>
                            <DocumentBar
                              hideScoreIntegration={showScoresUpdate}
                              docName={`RESEARCH WORK / PUBLICATION`}
                              documentUrl={eData?.ProjectURL}
                              onChange={handleScore}
                              handleVisibility={() => handleResearchWork(eData)}
                              score={score}
                              displayScore={eData?.Score}
                              handleSubmit={updateResearchWorkScoreHandler}
                              loading={updateResearchWorkMutation?.isLoading}
                            />
                          </td>
                        </tr>
                      )
                    )
                  : ""}
              </table>
            </div>
          ) : (
            <NotAvailable>Not Available</NotAvailable>
          )}
        </>
      )}
    </div>
  );
};

export default HRTraining;
